"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isThenable = void 0;

var _lodash = require("lodash");

/**
 * Check if argument is thenable
 *
 * @param {any} promise
 */
var isThenable = function isThenable(promise) {
  return !!(promise && (0, _lodash.isFunction)(promise.then) && (0, _lodash.isFunction)(promise.catch));
};

exports.isThenable = isThenable;
//# sourceMappingURL=is-thenable.js.map